import { render } from "./SecurityTrainingContent.vue?vue&type=template&id=db5ea002"
import script from "./SecurityTrainingContent.vue?vue&type=script&lang=js"
export * from "./SecurityTrainingContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__